import { useQuery } from '@tanstack/react-query';
import { getClouderServices } from './getClouderServices';
import { useSelector } from 'react-redux';

export default function useGetClouderServices() {
  const { username: id_clouder } = useSelector((store) => store.auth);

  return useQuery({
    queryKey: ['getClouderServices', id_clouder],
    queryFn: () => getClouderServices({ id_clouder }),
    staleTime: 1000 * 60 * 60 * 24,
    enabled: !!id_clouder,
  });
}
